/* eslint-disable import/prefer-default-export */
import React, { useCallback, useState } from 'react'
import s from './Panel.module.css'

import { EditCollection } from '../EditCollection'
import { ManageCollection } from '../ManageCollection'

const ACTIONS = [
  {
    name: 'edit',
    label: 'Edit collection',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_7029_132)">
          <path
            d="M13.3333 9.77335V13.3334C13.3333 13.687 13.1928 14.0261 12.9428 14.2762C12.6927 14.5262 12.3536 14.6667 12 14.6667H2.66665C2.31302 14.6667 1.97389 14.5262 1.72384 14.2762C1.47379 14.0261 1.33331 13.687 1.33331 13.3334V4.00002C1.33331 3.6464 1.47379 3.30726 1.72384 3.05721C1.97389 2.80716 2.31302 2.66669 2.66665 2.66669H6.22665"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 1.33331L14.6666 3.99998L7.99998 10.6666H5.33331V7.99998L12 1.33331Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7029_132">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: 'delete',
    label: 'Delete',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M13.5 3.5H2.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.5 6.5V10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.5 6.5V10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M12.5 3.5V13C12.5 13.1326 12.4473 13.2598 12.3536 13.3536C12.2598 13.4473 12.1326 13.5 12 13.5H4C3.86739 13.5 3.74021 13.4473 3.64645 13.3536C3.55268 13.2598 3.5 13.1326 3.5 13V3.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 3.5V2.5C10.5 2.23478 10.3946 1.98043 10.2071 1.79289C10.0196 1.60536 9.76522 1.5 9.5 1.5H6.5C6.23478 1.5 5.98043 1.60536 5.79289 1.79289C5.60536 1.98043 5.5 2.23478 5.5 2.5V3.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: 'archive',
    label: 'Archive',
  },
  {
    name: 'unarchive',
    label: 'Unarchive',
  },
]

export function Panel({ id, archived, afterDelete }) {
  const [inProgress, setInProgress] = useState(false)
  const [showEdit, setShowEdit] = useState(false)

  const handleAction = useCallback(
    (actionName) => async () => {
      async function deleteCollection() {
        try {
          setInProgress(true)
          const apiToken = localStorage.getItem('apiToken')

          const response = await fetch(`/api/v3/listing_collections/${id}`, {
            headers: {
              'API_TOKEN': apiToken,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            method: 'DELETE',
          })

          const data = await response.json()
          console.log(data)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        } finally {
          setInProgress(false)
          afterDelete()
        }
      }

      async function archiveCollection() {
        try {
          setInProgress(true)
          const apiToken = localStorage.getItem('apiToken')

          const response = await fetch(`/api/v3/listing_collections/${id}/archive`, {
            headers: {
              'API_TOKEN': apiToken,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            method: 'PUT',
          })

          const data = await response.json()
          console.log(data)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        } finally {
          setInProgress(false)
          afterDelete()
        }
      }

      async function unArchiveCollection() {
        try {
          setInProgress(true)
          const apiToken = localStorage.getItem('apiToken')

          const response = await fetch(`/api/v3/listing_collections/${id}/unarchive`, {
            headers: {
              'API_TOKEN': apiToken,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            method: 'PUT',
          })

          const data = await response.json()
          console.log(data)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        } finally {
          setInProgress(false)
          afterDelete()
        }
      }

      if (actionName === 'delete') {
        deleteCollection()
      }

      if (actionName === 'archive') {
        archiveCollection()
      }

      if (actionName === 'unarchive') {
        unArchiveCollection()
      }

      if (actionName === 'edit') {
        setShowEdit(true)
      }
    },
    []
  )

  return (
    <>
      <div className={s.root}>
        {ACTIONS.filter((action) => {
          if (archived) {
            return action.name === 'unarchive'
          }

          return action.name !== 'unarchive'
        }).map((actionItem) => (
          <button
            disabled={inProgress}
            type="button"
            onClick={handleAction(actionItem.name)}
            className={s.action}
            key={actionItem.name}
          >
            {actionItem.icon} {actionItem.label}
          </button>
        ))}
      </div>

      {showEdit && (
        <ManageCollection
          id={id}
          onClose={() => {
            setShowEdit(false)
            afterDelete()
          }}
        />
      )}
    </>
  )
}
